import { Locale, type LocalizedString } from "../Locale.js";

export const frequentlyAskedQuestionsPathMap = {
	[Locale.cs]: "casto-kladene-otazky" as const,
} satisfies LocalizedString;
